import { OperationVariables } from "@apollo/client";
import { RefetchFunction } from "@apollo/client/react/hooks/useSuspenseQuery";
import { Box, Stack, Typography } from "@mui/material";
import { BackPageButtonSearchParamName } from "components/buttons/BackPageButton/types";
import withSelectionCheckbox, { WithSelectionCheckboxInjectedProps } from "hocs/withSelectionCheckbox";
import QuestionItem from "pages/Skill/view/components/QuestionItem/components/QuestionItem";
import qs from "qs";
import { useEffect, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { CompetencyMapQuestion } from "./types";

interface QuestionProps {
  question: CompetencyMapQuestion;
  refetch: RefetchFunction<unknown, OperationVariables> | (() => void);
  competencyMapId: string;
}

const Question = ({
  question,
  refetch,
  competencyMapId,
  selectionMode,
  selectionCheckboxNode,
}: QuestionProps & WithSelectionCheckboxInjectedProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { scrollIntoViewId, ...params } = useMemo(() => qs.parse(searchParams.toString()), [searchParams]) as {
    scrollIntoViewId?: string;
  };

  useEffect(() => {
    if (ref && scrollIntoViewId && scrollIntoViewId === question.id) {
      ref.current?.scrollIntoView({ behavior: "smooth" });
      setSearchParams(qs.stringify(params), { replace: true });
    }
  }, [params, question.id, ref, scrollIntoViewId, setSearchParams]);

  return (
    <Stack
      ref={ref}
      direction='row'
      alignItems='flex-start'
      spacing={selectionMode ? 1.5 : 0}
      sx={{ backgroundColor: "white", borderRadius: 2, px: 2, paddingTop: 2 }}>
      {selectionCheckboxNode}
      <Stack sx={{ width: "100%" }}>
        <Stack
          direction='row'
          flexWrap='wrap'
          sx={{ columnGap: 2 }}>
          <Typography variant='subtitle18rg'>
            <b>Компетенция:</b> {question.competencyTitle}
          </Typography>
          <Typography variant='subtitle18rg'>
            <b>Блок знаний:</b> {question.knowledgeBlockTitle}
          </Typography>
          <Typography variant='subtitle18rg'>
            <b>Навык:</b> {question.skillTitle}
          </Typography>
        </Stack>
        <Box sx={{ backgroundColor: "white", borderRadius: 2 }}>
          <QuestionItem
            question={question}
            refetch={refetch}
            navigateToQuestionSearch={qs.stringify({
              [BackPageButtonSearchParamName.COMPETENCY_MAP_ID]: competencyMapId,
            })}
            showConfirmationInfo
            selectionMode={selectionMode}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default withSelectionCheckbox(Question);
